var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.auth && _vm.$store.state.auth.user && _vm.$store.state.root)?_c('h1',[_vm._v(" Page Not Found! ")]):_c('h1')])
}
var staticRenderFns = []

export { render, staticRenderFns }